<template>
  <a-skeleton active :loading="loading" :title="false" :paragraph="{rows: 8, width: 800}">
    <div>
      <a-form :layout="formLayout" :form="form">
        <a-form-item v-bind="formItemLayout" label="Current Password">
          <a-input-password
            :size="size"
            v-decorator="['old_password', { 
                  rules: [{ required: true, message: 'Please enter current password' }]}]"
            type="password"
            placeholder="Please enter current password"
          />
        </a-form-item>
        <a-form-item v-bind="formItemLayout" label="New Password">
          <a-input-password
            :size="size"
            v-decorator="['new_password', { 
                  rules: [{ required: true, message: 'Please enter new password' },{ validator: validateToNextPassword, }]}]"
            type="password"
            placeholder="Please enter new password"
          />
        </a-form-item>
        <a-form-item v-bind="formItemLayout" label="Confirm New Password">
          <a-input-password
            :size="size"
            v-decorator="['repeat_new_password', { 
                  rules: [{ required: true, message: 'Please confirm new password' }, { validator: compareToFirstPassword, }]}]"
            type="password"
            @blur="handleConfirmBlur"
            placeholder="Please confirm new password"
          />
        </a-form-item>
        <a-submit-button
          @submit="handleSubmit"
          :formLayout="formLayout"
          btn_text="Update password"
          styled="margin-top:0.5em; padding-left:4em;"
        />
      </a-form>
    </div>
  </a-skeleton>
</template>

<script>
import { formLayoutMixin } from "@/mixins/formLayout";

export default {
  mixins: [formLayoutMixin],
  data() {
    return {
      loading: false,
      confirmDirty: false,
      formLayout: "horizontal",
      size: "large",
      componentKey: 0,
      form: this.$form.createForm(this)
    };
  },
  methods: {
    compareToFirstPassword(rule, value, callback) {
      const form = this.form;
      if (value && value !== form.getFieldValue("new_password")) {
        callback("Two passwords that you enter is inconsistent!");
      } else {
        callback();
      }
    },
    validateToNextPassword(rule, value, callback) {
      const form = this.form;
      if (value && this.confirmDirty) {
        form.validateFields(["repeat_new_password"], {
          force: true
        });
      }
      callback();
    },
    handleConfirmBlur(e) {
      const value = e.target.value;
      this.confirmDirty = this.confirmDirty || !!value;
    },
    handleSubmit: function() {
      const form = this.form;
      form.validateFields(async (err, values) => {
        if (!err) {
          try {
            await this.$store.dispatch("axioms/createItem", {
              endpoint: `users/${this.$auth.session.id_payload.sub}/password`,
              data: values
            });
            await this.$notification.success({
              message: "Password updated!",
              description: "Your password is now updated."
            });
            form.resetFields();
          } catch (error) {
            console.error(error);
            let errorConfig = {};
            if (error.response.data.hasOwnProperty("new_password")) {
              errorConfig["new_password"] = {
                value: values.new_password,
                errors: [new Error(`${error.response.data.new_password}`)]
              };
            }
            if (error.response.data.hasOwnProperty("non_field_errors")) {
              errorConfig["old_password"] = {
                value: values.old_password,
                errors: [new Error(`${error.response.data.non_field_errors}`)]
              };
            }
            form.setFields(errorConfig);
          }
        } else {
          console.error("Error! Check submitted values: ", values);
        }
      });
    }
  }
};
</script>

<style>
</style>
